import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { switchMap, take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from './services/user.service';
import { User } from './models/Users.model';
import { AppService } from './services/app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { LeftSideNavComponent } from './left-side-nav/left-side-nav.component';
import { AsyncPipe } from '@angular/common';
import { AuthenticationService } from '@frontend-mono/shared-auth';
import { AppFooterComponent, AppHeaderComponent, LoadingOverlayDirective } from '@frontend-mono/shared-ui-kit';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    LeftSideNavComponent,
    AsyncPipe,
    AppHeaderComponent,
    AppFooterComponent,
    LoadingOverlayDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  public isIframe = false;
  public user: User | null = null;
  public readonly appService = inject(AppService);
  private authService = inject(AuthenticationService);
  private userService = inject(UserService);
  private readonly destroy = inject(DestroyRef);

  public ngOnInit(): void {
    this.isIframe = this.authService.isFrame;
    this.authService.authReady$
    .pipe(
      filter(Boolean),
      take(1),
      switchMap(() => this.userService.getSelf()),
      takeUntilDestroyed(this.destroy)
    )
    .subscribe({
      next: (user: User) => {
        console.log('User data fetched successfully');
        this.user = user;
      },
      error: (error) => {
        console.error('Error fetching user data:', error);
      }
    });
  }

  public toggleSideNav(): void {
    this.appService.toggleSideNav();
  }
}
